import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Activity } from 'lucide-react';
import MaquinariaLayout from '@/components/MaquinariaLayout';

export default function MaquinariaUso({ user, onLogout }) {
  return (
    <MaquinariaLayout user={user} onLogout={onLogout}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-[95%] mx-auto px-4 sm:px-6 lg:px-8 py-8"
      >
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center">
              <Activity className="w-6 h-6 mr-2" />
              Registro de Uso de Equipos
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-center py-12">
              <Activity className="w-16 h-16 mx-auto mb-4 text-gray-300" />
              <h3 className="text-lg font-semibold mb-2">Módulo de Uso</h3>
              <p className="text-gray-600 mb-4">
                Aquí se registrarán todos los usos que se hagan de cada equipo (horas de trabajo, combustible, tareas realizadas, etc.)
              </p>
              <Badge className="bg-blue-100 text-blue-700">Próximamente</Badge>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </MaquinariaLayout>
  );
}
